import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=44cc3928&scoped=true&"
import script from "./FilesTable.vue?vue&type=script&lang=js&"
export * from "./FilesTable.vue?vue&type=script&lang=js&"
import style0 from "./FilesTable.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./FilesTable.vue?vue&type=style&index=1&id=44cc3928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc3928",
  null
  
)

export default component.exports